import { JsonProperty } from 'json-typescript-mapper/index';

export class MarketdateBoothGeoData {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('mplaceId')
  public mplaceId?: number;

  @JsonProperty('mplaceKeyword')
  public mplaceKeyword?: string;

  @JsonProperty('mplaceLatitude')
  public mplaceLatitude?: string;

  @JsonProperty('mplaceLongitude')
  public mplaceLongitude?: string;

  @JsonProperty('mdayId')
  public mdayId?: number;

  @JsonProperty('mdayDayString')
  public mdayDayString?: string;

  @JsonProperty('mdayBranchString')
  public mdayBranchString?: string;

  @JsonProperty('mdayNumber')
  public mdayNumber?: string;

  @JsonProperty('mdateId')
  public mdateId?: number;

  @JsonProperty('mdateEvasiveDate')
  public mdateEvasiveDate?: string;

  @JsonProperty('mdateStatus')
  public mdateStatus?: string;

  @JsonProperty('mbId')
  public mbId?: number;

  @JsonProperty('mbStatus')
  public mbStatus?: string;

  @JsonProperty('suNumber')
  public suNumber?: number;

  @JsonProperty('suIdentification')
  public suIdentification?: string;

  @JsonProperty('mmasterFirstname')
  public mmasterFirstname?: string;

  @JsonProperty('mmasterLastname')
  public mmasterLastname?: string;

  @JsonProperty('mmasterNumber')
  public mmasterNumber?: string;

  @JsonProperty('merchantId')
  public merchantId?: number;

  @JsonProperty('merchantCompany')
  public merchantCompany?: string;

  @JsonProperty('merchantCompanyAdditional')
  public merchantCompanyAdditional?: string;

  @JsonProperty('merchantMerchantNumber')
  public merchantMerchantNumber?: number;

  @JsonProperty('geTimestamp')
  public geTimestamp?: string;

  @JsonProperty('geLatitude')
  public geLatitude?: number;

  @JsonProperty('geLongitude')
  public geLongitude?: number;

  @JsonProperty('geManual')
  public geManual?: number;

  constructor() {
    this.id = void 0;
    this.mplaceId = void 0;
    this.mplaceKeyword = void 0;
    this.mplaceLatitude = void 0;
    this.mplaceLongitude = void 0;
    this.mdayId = void 0;
    this.mdayDayString = void 0;
    this.mdayBranchString = void 0;
    this.mdayNumber = void 0;
    this.mdateId = void 0;
    this.mdateEvasiveDate = void 0;
    this.mdateStatus = void 0;
    this.mbId = void 0;
    this.mbStatus = void 0;
    this.suNumber = void 0;
    this.suIdentification = void 0;
    this.mmasterFirstname = void 0;
    this.mmasterLastname = void 0;
    this.mmasterNumber = void 0;
    this.merchantId = void 0;
    this.merchantCompany = void 0;
    this.merchantCompanyAdditional = void 0;
    this.merchantMerchantNumber = void 0;
    this.geTimestamp = void 0;
    this.geLatitude = void 0;
    this.geLongitude = void 0;
    this.geManual = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/marketdate-booth-geo-data.model.ts